// extracted by mini-css-extract-plugin
export var contrastLow = "_3k-1";
export var externalLink = "_3k-2";
export var externalLinkIcon = "_3k-3";
export var link = "_3k-0";
export var linkLabel = "_3k-4";